<template>
  <div>
    id: {{ id }}
    item: {{ local_item }}
    <QuestionAsked 
      :item="local_item"
    />
  </div>
</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import QuestionAsked from '@/view/components/questions/QuestionAsked.vue';

export default {
  name: 'SurveyPreviewQuestion',
  components: {
    QuestionAsked,
  },
  data() {
    return {
      local_item: {
        type: 'SELECT'
      },

      id: null,
    };
  },
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'companies', 'periods', 'settings']),

  },
  watch: {
    currentCompanyId() {
      
    },
  },
  methods: {
    async fetch_question(id) {
      console.log('fetching', id);
      const res = await axios.get(`/question_form/item/${id}`);
      console.log('res', res.status, res.data);
      if (res.status === 200) {
        return res.data;
      }
      
      return {};
    }
  },
  async mounted() {
    console.log('mounted', this.$route.params.id);
    const id = parseInt(this.$route.params.id+'');
    this.id = id;
    const item = await this.fetch_question(id);
    this.local_item = item;
  }
};
</script>

<style scoped>

</style>
